<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div>
      <div class="border" style="background-color: white;padding: 1.5rem;border-radius: 5px;">
        <div class="row">
          <div class="col-lg-12 rounded " style="background-color: white;">
            <div class="row">
              <!-- left side bar  -->
              <div class="col-md-5">
                <h3 class="text-center ">Edit Album</h3>
                <div class="form-group">
                  <label for="albumName">Album Name</label>
                  <input id="albumName" v-model="album_name" class="form-control" placeholder="Enter Album Name"
                         type="text">
                </div>
                <div class="form-group">
                  <label for="albumDescription">Album Description</label>
                  <textarea id="albumDescription" v-model="album_description" class="form-control"
                            placeholder="Album Description"
                            rows="3"></textarea>
                </div>
                <div class="form-group">
                  <label for="slug">Slug</label>
                  <input id="slug" v-model="album_slug" class="form-control" disabled placeholder="Enter Slug"
                         type="text">
                </div>
                <div class="form-group mb-3">
                  <label for="albumStatus">Album Status</label>
                  <select id="albumStatus" v-model="active_yn" class="form-control">
                    <option disabled selected>Choose...</option>
                    <option value="Y">Active</option>
                    <option value="N">Inactive</option>
                  </select>
                </div>
                <div class="form-group  ">
                  <label for="featuredYN">Featured?</label>
                  <select id="featuredYN" v-model="featured_yn" class="form-control">
                    <option disabled selected>Choose...</option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                  </select>
                </div>
                <button class="btn btn-primary" type="button" @click="showAddImages = true">
                  Add Images
                </button>
                <button class="btn btn-success float-end" type="button" @click="updateAlbum">Save Changes</button>
              </div>
              <!-- Right side bar  -->
              <div class="col-md-7" div>
                <div class="row">
                  <div class="col-md-12">
                    <h3 class="text-center mb-3">Album Images</h3>
                    <div class="row  rounded border mx-3 p-3">
                      <template v-for="(info, index) in selectedMediaForAlbum" :key="index">
                        <div class="col-3 mb-3">
                          <button aria-label="Close" class="btn-danger mb-1" style="padding: 0%;"
                                  type="button" @click="selectedMediaForAlbum.splice(index, 1)">
                            <i class="fa-solid fa-xmark"></i>
                          </button>
                          <img :src="all_images.find(x => x.media_file_id === info).file_path" alt="media"
                               class="img-thumbnail"
                               style="display:flex;justify-content: center;align-items: center; width:120px; height: 120px; background-color: rgb(244, 245, 245);border-radius: 6px;">
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  modal-->
      <div v-if="showAddImages">
        <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
             class="modal fade show" role="dialog" style="display: block;"
             tabindex="-1">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Images to Album</h5>
                <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                        type="button" @click="showAddImages = false"></button>
              </div>
              <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                <selectable-media-component :fetchImageIds="selectedMediaForAlbum"
                                            @imgList="getImages"/>
              </div>
              <div class="modal-footer">
                <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                        @click="showAddImages = false">Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MediaService from "@/services/media.service";
import Config from '@/config/index.js';
import selectableMedia from "@/components/Media/SelectableMedia.vue";

export default {
  name: "EditAlbum",
  components: {
    "selectable-media-component": selectableMedia,
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Media',
          to: '/album/show'
        }, {
          text: 'Edit Album',
          to: '/album/:id'
        },
      ],
      showAddImages: false,
      id: this.$route.params.id,
      album_id: null,
      album_name: null,
      album_slug: null,
      active_yn: 'Y',
      featured_yn: 'N',
      album_description: null,
      all_images: [],
      selectedMediaForAlbum: [],
      album: {
        id: null,
        album_name: null,
        slug: null,
        active_yn: 'Y',
        featured_yn: 'N',
        album_description: null,
        mediaIds: [],
      },
    }
  },
  mounted() {
    this.fetchMedia();
  },
  methods: {
    getImages(data) {
      this.selectedMediaForAlbum = [];
      const parsedData = JSON.parse(data);
      parsedData.forEach((element) => {
        this.selectedMediaForAlbum.push(
            element[0].media_file_id,
        );
      });
    },
    async fetchMedia() {

      try {
        const response = await MediaService.getAllMedia();
        this.all_images = response.data;

        this.all_images.forEach(element => {
          element.selected = false;
          element.file_path = Config.apiFileBasePath + element.file_path;
          element.thumbnail_file_path_show = Config.apiPortalFileBasePath + element.thumbnail_file_path;
        });
        this.fetchAlbum();
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAlbum() {
      try {
        const response = await MediaService.getAlbum(this.id);
        this.album = response.data;
        this.album_id = this.album.id;
        this.album_name = this.album.album_name;
        this.album_slug = this.album.slug;
        this.active_yn = this.album.active_yn;
        this.featured_yn = this.album.featured_yn;
        this.album_description = this.album.album_description;
        const mediaIds = await MediaService.getMediaIdsForAlbum(this.album_id);
        const mediaIdsArray = [];
        mediaIds.data.forEach(element => {
          mediaIdsArray.push(element.media_file_id);
        });
        this.album.mediaIds = mediaIdsArray;
        this.selectedMediaForAlbum = mediaIdsArray;

        this.all_images.forEach(element => {
          if (this.album.mediaIds.includes(element.id)) {
            element.selected = true;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    showNotification(type, message) {
      this.$notify({
        type: type,
        title: 'Upload Media',
        text: message
      });
    },
    async updateAlbum() {
      try {
        this.setAlbumData();
        const response = await MediaService.updateAlbum(this.album);
        const result = response.data;
        if (result.messageCode === 1) {
          this.showNotification('success', result.message);
        } else {
          this.showNotification('error', result.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    setAlbumData() {
      this.album.id = this.album_id;
      this.album.album_name = this.album_name;
      this.album.slug = this.album_slug;
      this.album.active_yn = this.active_yn;
      this.album.featured_yn = this.featured_yn;
      this.album.album_description = this.album_description;
      this.album.mediaIds = this.selectedMediaForAlbum;
    },
  },
}
</script>

